import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';
import { RegisterTypes, RateTypes } from '../enums';
import { LastReadingsAndOrder } from '@app/zahlerstand/models/zahlerstand.state';

@Pipe({
  name: 'getTariffType',
})
export class GetTariffTypePipe implements PipeTransform {
  transform(value?: LastReadingsAndOrder | null): string {
    if (isEmpty(value)) {
      return '';
    }

    const rateTypeValue = value.rateType?.value;
    const registerTypeValue = value.registerType?.value;

    const secondSegment = value.obisCode?.split(':')?.[1] ?? '';
    const obisCode = secondSegment.charAt(0);

    switch (obisCode) {
      case '1': {
        if (registerTypeValue === 'T0') {
          return RegisterTypes.ET;
        }
        return rateTypeValue === RateTypes.EZH ? RegisterTypes.HT : RegisterTypes.NT;
      }
      case '2':
        return RegisterTypes.EINSPEISUNG;
      default:
        return '';
    }
  }
}
